if (!customElements.get('sgh-product-inquiry')) {
  customElements.define('sgh-product-inquiry', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) {
        window.addEventListener('hashchange', this.openFromLocation);
        return;
      }
      this.initialized = true;
      this.dialog = this.querySelector('dialog');
      this.opener = this.querySelector('[data-inquiry-open]');
      this.form = this.querySelector('form');
      this.opener.addEventListener('click', () => this.open());
      this.querySelector('[data-inquiry-close]').addEventListener('click', () => this.dialog.close());
      this.dialog.addEventListener('click', (event) => {
        if (event.target !== this.dialog) return;
        const bounds = this.dialog.getBoundingClientRect();
        if (event.clientX < bounds.left || event.clientX > bounds.right ||
            event.clientY < bounds.top || event.clientY > bounds.bottom) this.dialog.close();
      });
      this.dialog.addEventListener('keydown', (event) => {
        if (event.key !== 'Tab') return;
        const controls = [...this.dialog.querySelectorAll(
          'button:not([disabled]), input:not([type="hidden"]):not([disabled]), select:not([disabled]), textarea:not([disabled]), a[href], [tabindex="0"]'
        )].filter((element) => element.getClientRects().length > 0);
        const first = controls[0];
        const last = controls[controls.length - 1];
        if (!first) return;
        if (event.shiftKey && (document.activeElement === first || !controls.includes(document.activeElement))) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && (document.activeElement === last || !controls.includes(document.activeElement))) {
          event.preventDefault();
          first.focus();
        }
      });
      this.dialog.addEventListener('close', () => {
        this.unlockScroll();
        if (this.opener.isConnected) this.opener.focus({ preventScroll: true });
      });
      this.querySelector('[data-inquiry-variant]')?.addEventListener('change', () => this.syncSku());
      this.form.addEventListener('submit', () => this.syncSku());
      // The native form POST keeps Shopify validation and CAPTCHA intact.
      // Hash chooses the submitted form when more than one product is featured.
      this.openFromLocation = () => {
        const hash = window.location.hash.slice(1);
        const status = this.querySelector('[data-inquiry-status]');
        const first = document.querySelector('sgh-product-inquiry');
        if ((hash === this.form.id && status) ||
            (hash === 'sgh-inquiry' && this === first) ||
            (status && !hash && this === first)) {
          this.open();
          status?.focus();
        }
      };
      window.addEventListener('hashchange', this.openFromLocation);
      this.openFromLocation();
    }
    open() {
      if (this.dialog.open) return;
      this.dialog.showModal();
      document.documentElement.classList.add('sgh-inquiry-open');
    }
    syncSku() {
      const variant = this.querySelector('[data-inquiry-variant]');
      if (variant) this.querySelector('[data-inquiry-sku]').value = variant.selectedOptions[0]?.dataset.sku || '';
    }
    unlockScroll() {
      if (!document.querySelector('.sgh-inquiry__dialog[open]')) {
        document.documentElement.classList.remove('sgh-inquiry-open');
      }
    }
    disconnectedCallback() {
      window.removeEventListener('hashchange', this.openFromLocation);
      if (this.dialog?.open) this.dialog.close();
      this.unlockScroll();
    }
  });
}
